import { type FormEvent, useState } from 'react';
import { resetPassword } from '@/lib/authClient';
import { AuthCard, authButtonClass, authInputClass } from './AuthCard';

/** Complete a password reset using the emailed `?token=`. */
export const ResetPasswordPage = () => {
  const token = new URLSearchParams(window.location.search).get('token') ?? '';
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (event: FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    const result = await resetPassword(password, token);
    setSubmitting(false);
    if (result.error) {
      setError('This reset link is invalid or has expired.');
      return;
    }
    window.location.href = '/?passwordReset=1';
  };

  return (
    <AuthCard>
      {token ? (
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <label className="flex flex-col gap-1 text-sm font-medium text-content-text">
            New password
            <input
              type="password"
              autoComplete="new-password"
              required={true}
              minLength={8}
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className={authInputClass}
            />
          </label>
          {error ? <p className="text-sm text-error-main">{error}</p> : null}
          <button type="submit" disabled={submitting} className={authButtonClass}>
            {submitting ? 'Updating…' : 'Update password'}
          </button>
        </form>
      ) : (
        <p className="text-center text-sm text-content-deemphasized">
          This reset link is missing its token.
        </p>
      )}
      <div className="mt-6 text-center text-xs text-content-subtle">
        <a href="/" className="hover:text-secondary-emphasized">
          Back to sign in
        </a>
      </div>
    </AuthCard>
  );
};
